import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import './styles/globals.css';

/**
 * Bootstrap order:
 *   1. Wait for Office.onReady — Office JS must be initialized before any
 *      Word.run() or Office.context.* calls work. Mounting React before this
 *      silently breaks document I/O.
 *   2. Mount React.
 */
Office.onReady(() => {
  const container = document.getElementById('root');
  if (!container) {
    // eslint-disable-next-line no-console
    console.error('[NyayAssist] #root container missing');
    return;
  }
  ReactDOM.createRoot(container).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
